// Add class to body-element on tab click

const tabHighlight = () => {
  const highLightClass = 'is-tabbed'

  const self = {
    init () {
      self.addEventListeners()
    },
    onKeyDown (e) {
      if (!e) e = window.event
      const keyCode = e.keyCode || e.which
      const tabKey = 9

      if (keyCode === tabKey) {
        document.body.classList.add(highLightClass)
      }
    },
    onMouseDown () {
      document.body.classList.remove(highLightClass)
    },
    addEventListeners () {
      document.body.addEventListener('keydown', self.onKeyDown)
      document.body.addEventListener('mousedown', self.onMouseDown)
    }
  }

  return self
}

export default tabHighlight
